import { navLinks } from "@/mocks/leakHome";

export default function Footer() {
  return (
    <footer className="w-full bg-red-950 text-red-100">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-4 md:px-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-600 text-white">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="text-xl font-black text-white">
              52<span className="text-amber-400">爆料</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-red-200/80">
            这里是把「想说又没处说」发上墙的地方。吃瓜、倾诉、内幕，匿名投稿或私信小编，我们都接得住。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-white">快速入口</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-red-200/80 transition hover:text-white">
                  {l.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-white">投稿方式</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-red-200/80">
            <li className="flex items-center gap-2">
              <i className="ri-mail-send-line"></i> 私信投稿 52爆料
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-message-3-line"></i> 评论区「我想说」接龙
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-rocket-2-line"></i> 带 #上墙 投稿更显眼
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-white">平台规范</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-red-200/80">
            <li>杜绝造谣与人身攻击</li>
            <li>严格保护投稿人隐私</li>
            <li>违规内容一律先审后发</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-red-900">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-red-200/70 sm:flex-row md:px-6">
          <p>© 2026 52爆料 · 匿名投稿与上墙社区</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-lock-2-line"></i> 本页为演示页面，投稿仅作展示，不采集真实信息
          </p>
        </div>
      </div>
    </footer>
  );
}